import { constants } from '../constants';

const INITIAL_STATE = {
  loading: false,
  automatic_wash_codes: [],
  total: 0,
  header: {},
  footer: {},
};

export const textileReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case constants.textile.SET_AUTOMATIC_WASH_CODES_LOADING:
      return {
        ...state,
        loading: action.flag,
      };
    case constants.textile.SET_AUTOMATIC_WASH_CODES:
      return {
        ...state,
        automatic_wash_codes: action.automatic_wash_codes,
        total: action.count,
        header: action.header,
        footer: action.footer,
      };
    case constants.textile.CLEAR_AUTOMATIC_WASH_CODES:
      return {
        ...INITIAL_STATE,
      };
    default:
      return state;
  }
};
